const wine_dir = "wines";
export const WINES = [
    {
        "image" : "./" + wine_dir + "/torbreck-2021.jpg",
        "name" : "Torbreck Woodcutter's Shiraz",
        "vintage" : 2021,
        "notes" : "This was the first wine I tried after becoming fascinated about the world of wine. I was seriously (keyword) trying to experience it - smell, taste, sight, touch. The smell was very nice and the taste even better. There was the hint of peppery taste often found in Shiraz and overall the balance was excellent. A full bodied wine. Reminded me of sunset over a field that was drying out. Huge fan - definitely got me very excited for the world of wine before me",
        "variety" : "Shiraz",
        "region" : "Barossa Valley, Australia",
        "priceCAD" : 29.95
    },
    {
        "image" : "./" + wine_dir + "/campo-viejo-2021.jpg",
        "name" : "Campo Viejo Rioja Tempranillo",
        "vintage" : 2021,
        "notes" : "Purchased to enjoy with a chorizo fried rice dish, but did not have a cork screw on hand. Attempted to uncork by screwing a screw in and pulling with hammer but wasn't too effective and I didn't want to risk anything. Eventually acquired a corkscrew to enjoy this wine. Overall, very similar to the Torbreck except lighter. Still enjoyable but definitely not as complex and forthcoming. Was not able to finish the bottle as degradation ruined it. Also the cork was damaged (side that was in the wine) and bits were falling in. Given it was almost half the price of the Torbreck, it was still a good experience and now I know Tempranillo is pretty good",
        "variety" : "Tempranillo",
        "region" : "Rioja, Spain",
        "priceCAD" : 16.45
    },
    {
        "image" : "./" + wine_dir + "/brouilly-2018.jpg",
        "name" : "Domaine d'Argenson Les Pierreux Brouilly",
        "vintage" : 2018,
        "notes" : "Pretty light overall, tasted some minerals - kinda like pig blood curd (?). The sensations did not linger on the tongue. It was definitely questionable on the first day, but subsequent days of drinking were quite enjoyable but the mineral taste was gone. Reminded me of living rocks, a plant recently purchased for a friend",
        "variety" : "Gamay",
        "region" : "Beaujolais, France",
        "priceCAD" : 22.95
    },
    {
        "image" : "./" + wine_dir + "/carnivor-zin-2020.jpeg",
        "name" : "Carnivor Zinfandel",
        "vintage" : 2020,
        "notes" : "First thing I noticed was the sweetness (9g/L). The balance was a bit off but it was a very sippable wine. Next few days felt like the balance was improving and it became very enjoyable. Fruity and sweet, couldn't get enough!",
        "variety" : "Zinfandel",
        "region" : "Lodi, California, USA",
        "priceCAD" : 18.95
    },
    {
        "image" : "./" + wine_dir + "/catena-malbec-2021.jpg",
        "name" : "Catena Malbec",
        "vintage" : 2021,
        "notes" : "An awesome wine. Great balance, not bitter, very smooth. Med-full bodied, relatively lower tannins and acidity. A longer finish. Oaky and black fruit aroma and tastes. Eager to try more malbecs.",
        "variety" : "Malbec",
        "region" : "Mendoza, Argentina",
        "priceCAD" : 23.95
    },
    {
        "image" : "./" + wine_dir + "/apothic-red.jpg",
        "name" : "Apothic Red",
        "vintage" : 2020,
        "notes" : "Med-full bodied. Med tannins, med-high acidity. Solid wine, not too complex but nice to drink. Do not have with spicy food!!",
        "variety" : "Blend (Syrah, Zinfandel, Merlot)",
        "region" : "California, USA",
        "priceCAD" : -1
    },
    {
        "image" : "./" + wine_dir + "/roda-2019.jpg",
        "name" : "Roda Reserva",
        "vintage" : 2019,
        "notes" : "A gift from a friend who visited Spain. Full bodied, med-high acidity, high tannins. Fruity and oaky. Much more complex than the previous Rioja I had. Very enjoyable to drink with plenty of flavours and properties working together in a well-balanced fashion.",
        "variety" : "Tempranillo",
        "region" : "Rioja, Spain",
        "priceCAD" : -1
    },
    {
        "image" : "./" + wine_dir + "/wolf-blass-2002.jpg",
        "name" : "Wolf Blass Red Label Shiraz Cabernet Sauvignon",
        "vintage" : 2002,
        "notes" : "Received from a family friend who no longer drinks wine. First time trying such an aged wine and I'm pretty sure this one isn't supposed to be aged. An interesting experience from the uncorking. The cork was falling apart and I tried to carefully remove it. Thankfully no chunks fell into the wine but a few crumbs did but honestly no big deal. I forgot sediment was a thing so upon pour and examining there were a lot of particles floating around. Again, didn't really affect the experience. Immediately noticed the colour was brownish. Wasn't getting much aromas from it. At this point I feared the worst and that the wine was undrinkable. Tasting it wasn't too bad though. Low body and tannins, high acidity but not too overpowering. Definitely not what I expected from a Shiraz/Cab Sauv. Overall, it wasn't bad and I will plan to finish the whole bottle but it is safe to say I will not be hunting more of these bottles",
        "variety" : "Shiraz, Cabernet Sauvignon",
        "region" : "Southeastern Australia",
        "priceCAD" : -1
    },
    {
        "image" : "./" + wine_dir + "/montes-alpha-2021.jpg",
        "name" : "Montes Alpha Carmenere",
        "vintage" : 2021,
        "notes" : "Medium bodied, medium acidity, low-med tannins. Fruit forward, hints of pepper, mocha, cola, chocolate. Enjoyable wine, but nothing that really stood out to me.",
        "variety" : "Carmenere",
        "region" : "Colchagua Valley, Chile",
        "priceCAD" : 19.95
    },
    {
        "image" : "./" + wine_dir + "/magnotta-1996.jpg",
        "name" : "Magnotta Millenium",
        "vintage" : 1996,
        "notes" : "A wine that's older than me! Wasn't careful when uncorking and had to push the cork in. An enjoyable wine, hints of mint and vanilla. Seemed a bit aged for too long.",
        "variety" : "Cabernet Sauvignon",
        "region" : "Ontario, Canada",
        "priceCAD" : -1
    },
    {
        "image" : "./" + wine_dir + "/quinta-de-ventozelo-2018.jpg",
        "name" : "Quinta de Ventozelo",
        "vintage" : 2018,
        "notes" : "Not a fan of this one. Not much aroma, tasting was very flat like water and alcohol. Might have drank this past it's window",
        "variety" : "Touriga Franca",
        "region" : "Douro, Portugal",
        "priceCAD" : -1
    },
    {
        "image" : "./" + wine_dir + "/boschendal-2020.jpg",
        "name" : "Boschendal ",
        "vintage" : 2020,
        "notes" : "Forgot to jot down notes after tasting. From what I remember, it was more earthy tones. Medium-full body and medium tannins. Overall enjoyable",
        "variety" : "Pinotage",
        "region" : "Stellenbosch, South Africa",
        "priceCAD" : 20.95
    },
    {
        "image" : "./" + wine_dir + "/anciano-2022.jpg",
        "name" : "Anciano Rioja Garnacha",
        "vintage" : 2022,
        "notes" : "A simple dry wine. Medium-full body, medium tannins. Some peppery notes. Not bad for the cost but definitely feels like its lacking in complexity",
        "variety" : "Garnacha",
        "region" : "Rioja, Spain",
        "priceCAD" : 12.95
    },
    {
        "image" : "./" + wine_dir + "/via-2020.jpg",
        "name" : "Via Caritatis Vox Angelorum",
        "vintage" : 2020,
        "notes" : "Dry, high tannins, long finish, alcohol was a little oppressive at times. Spice notes. A lovely wine.",
        "variety" : "Syrah, Grenache",
        "region" : "Southern Rhône, France",
        "priceCAD" : 17.95
    },
    {
        "image" : "./" + wine_dir + "/intrinsic.jpg",
        "name" : "Intrinsic Red Blend",
        "vintage" : 2020,
        "notes" : "Purchased during trip to Seattle. Dry, full bodied wine with tannins. Mix of dark fruit and oaky aromas",
        "variety" : "Malbec, Cabernet Franc",
        "region" : "Washington, United States",
        "priceCAD" : 44.42
    }
]
